const KEY = 'nexops-chunk-reload-at';
const MIN_GAP_MS = 30_000;

/**
 * Po wdrożeniu stare fragmenty aplikacji (`assets/Xxx-<hash>.js`) znikają z serwera. Karta otwarta przed wdrożeniem
 * próbuje je dociągnąć i dostaje 404 („Failed to fetch dynamically imported module”). Zamiast ekranu błędu
 * przeładowujemy stronę (nowy index.html wskazuje nowe pliki) — najwyżej raz na 30 s, żeby nie wpaść w pętlę.
 */
export function installChunkReload(): void {
  window.addEventListener('vite:preloadError', (event) => {
    let last = 0;
    try {
      last = Number(sessionStorage.getItem(KEY) ?? 0);
    } catch {
      /* sessionStorage niedostępny — przeładujemy jednorazowo bez ochrony przed pętlą */
    }
    if (Date.now() - last < MIN_GAP_MS) return; // już próbowaliśmy: zostaw błąd, niech widać problem
    event.preventDefault();
    try {
      sessionStorage.setItem(KEY, String(Date.now()));
    } catch {
      /* ignore */
    }
    window.location.reload();
  });
}
